import request from '@/utils/request'


export function companytechnology(query) {
    return request({
        url: '/website/websitehome/companytechnology',
        method: 'get',
        params: query
    })
}

export function companytechnologyById(query) {
    return request({
        url: '/website/websitehome/companytechnologyById',
        method: 'get',
        params: query
    })
}

